<template lang="html">

  <section class="home-area -eventos">

    <div class="container">
      <h2 class="main-title">Próximos Eventos</h2>
      <div class="contenedor-eventos row-start ais">
        <evento :key="key" :data="evento" v-for="(evento,key) in eventos.slice(0,3)"></evento>
      </div>
      <router-link class="link" :to="$t('enlaces.eventos')">Ver más</router-link>
    </div>

  </section>

</template>

<script lang="js">

  import evento from '@/components/parts/evento-el';

  import {mapActions,mapGetters} from 'vuex';

  export default {
    name: 'eventos-home',
    mounted(){
      if(!!!this.eventos){
        this.requestEventos();
      }
    }, 
    methods : {
      ...mapActions(['requestEventos'])
    },
    components: {
      'evento': evento
    },
    computed : {
      ...mapGetters({
        eventos : 'getEventos'
      })
    }

  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/eventos.vue